/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AccountingMetricRepresentation } from './AccountingMetricRepresentation';
import {
    AccountingMetricRepresentationFromJSON,
    AccountingMetricRepresentationFromJSONTyped,
    AccountingMetricRepresentationToJSON,
    AccountingMetricRepresentationToJSONTyped,
} from './AccountingMetricRepresentation';

/**
 * 
 * @export
 * @interface AccountGroupRepresentation
 */
export interface AccountGroupRepresentation {
    /**
     * 
     * @type {string}
     * @memberof AccountGroupRepresentation
     */
    key: string;
    /**
     * 
     * @type {string}
     * @memberof AccountGroupRepresentation
     */
    nameKey: string;
    /**
     * 
     * @type {Array<AccountingMetricRepresentation>}
     * @memberof AccountGroupRepresentation
     */
    metrics?: Array<AccountingMetricRepresentation>;
}

/**
 * Check if a given object implements the AccountGroupRepresentation interface.
 */
export function instanceOfAccountGroupRepresentation(value: object): value is AccountGroupRepresentation {
    if (!('key' in value) || value['key'] === undefined) return false;
    if (!('nameKey' in value) || value['nameKey'] === undefined) return false;
    return true;
}

export function AccountGroupRepresentationFromJSON(json: any): AccountGroupRepresentation {
    return AccountGroupRepresentationFromJSONTyped(json, false);
}

export function AccountGroupRepresentationFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountGroupRepresentation {
    if (json == null) {
        return json;
    }
    return {
        
        'key': json['key'],
        'nameKey': json['nameKey'],
        'metrics': json['metrics'] == null ? undefined : ((json['metrics'] as Array<any>).map(AccountingMetricRepresentationFromJSON)),
    };
}

export function AccountGroupRepresentationToJSON(json: any): AccountGroupRepresentation {
    return AccountGroupRepresentationToJSONTyped(json, false);
}

export function AccountGroupRepresentationToJSONTyped(value?: AccountGroupRepresentation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key': value['key'],
        'nameKey': value['nameKey'],
        'metrics': value['metrics'] == null ? undefined : ((value['metrics'] as Array<any>).map(AccountingMetricRepresentationToJSON)),
    };
}

